var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimeWordsIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.1666 17.0007C31.1666 24.8207 24.8199 31.1673 16.9999 31.1673C9.17992 31.1673 2.83325 24.8207 2.83325 17.0007C2.83325 9.18065 9.17992 2.83398 16.9999 2.83398C24.8199 2.83398 31.1666 9.18065 31.1666 17.0007Z",
    stroke: "#1D2C49",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2557 21.5045L17.864 18.8837C17.099 18.4303 16.4757 17.3395 16.4757 16.447V10.6387",
    stroke: "#F5A39B",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5495 25.0029L27.4583 22L14 28.375L16.4713 34.7025L18.1778 32.6819L20.7374 34.7025L24.5769 32.2553L30.5495 25.0029Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4186 24.1943C23.8436 25.7243 25.0336 26.9143 26.5636 27.3393",
    stroke: "#1D2C49",
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1406 23.4739L19.1256 28.4889C18.9273 28.6872 18.7431 29.0555 18.7006 29.3247L18.4314 31.2372C18.3322 31.9314 18.8139 32.4131 19.5081 32.3139L21.4206 32.0447C21.6898 32.0022 22.0722 31.818 22.2564 31.6197L27.2714 26.6047C28.1356 25.7406 28.5464 24.7347 27.2714 23.4597C26.0106 22.1989 25.0047 22.6097 24.1406 23.4739Z",
    stroke: "#1D2C49",
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeWordsIcon);
export default __webpack_public_path__ + "static/media/time-words-icon.12d748604ad3c4f6f71496f0a0419eb9.svg";
export { ForwardRef as ReactComponent };